module.exports = __webpack_public_path__ + "images/emoji/feelsgood.4fab33ad41d47ca1e410.png";